module.exports = __webpack_public_path__ + "static/media/arrowDownRight.6412c5c8.svg";